// extracted by mini-css-extract-plugin
module.exports = {"category":"CategoryList_category___QFMe"};